import { h, F as Fragment } from './index-f214f983.js';

const ItemDisplayGuard = (props, children) => {
    if (!props.hasItems || !props.firstRequestExecuted) {
        return;
    }
    return h(Fragment, null, ...children);
};

export { ItemDisplayGuard as I };

//# sourceMappingURL=item-display-guard-9f5b7b4e.js.map